import { ComponentType } from 'react';
import { HudFormContent } from './attorneyHud/hudEditModal';
import { EntityEditModal } from './borrowerEntity/entityEditModal';
import { PropertyTaxesEditModal } from './propertyTaxes/propertyTaxesEditModal';
import { UwHudEditModal } from './uwHud/uwHudEditModal';
import { GC_LICENSE,BROKER_LICENSE, ARTICLES_OF_INCORPORATION, BORROWER_LLC_CERTIFICATE_OF_GOOD_STANDING, BORROWING_CORP_STOCK_CERTIFICATE, BYLAWS, CERTIFICATE_OF_EXISTENCE, CERTIFICATE_OF_FORMATION, CERTIFICATE_OF_GOOD_STANDING, CERTIFICATE_OF_GOOD_STANDING_BASE, EIN_LETTER, FOREIGN_ENTITY_REGISTRATION, HOA, HUD, HUD_DOC, OPERATING_AGREEMENT, PURCHASE_CONTRACT, TAX_CERTIFICATE, UW_HUD, WHOLESALER_CONTRACT, CERT_OF_FORMATION_OR_INC, CERT_OF_GOOD_STANDING_OR_EXISTENCE, OPERATING_AGREEMENT_BYLAWS_STOCK } from '@roc/feature-documents';
import { WholesalerContractEditModal } from './wholesalerContract/wholesalerContractEditModal';
import { HoaEditModal } from './hoa/hoaEditModal';
import { PurchaseContractEditModal } from './purchaseContract/purchaseContractEditModal';
import { LicenseEditModal } from './license/licenseEditModal';

export interface DocReviewEditContentResolverProps {
  itemName: string;
  open: boolean;
}

export const DocReviewEditContentResolver = ({ itemName, open }: DocReviewEditContentResolverProps) => {
  const Content = {
    [EIN_LETTER]: EntityEditModal,
    [HUD]: HudFormContent,
    [TAX_CERTIFICATE]: PropertyTaxesEditModal,
    [UW_HUD]: UwHudEditModal,
    [HUD_DOC]: UwHudEditModal,
    [HOA]: HoaEditModal,
    [PURCHASE_CONTRACT]: PurchaseContractEditModal,
    [WHOLESALER_CONTRACT]: WholesalerContractEditModal,
    [CERTIFICATE_OF_FORMATION]: EntityEditModal,
    [ARTICLES_OF_INCORPORATION]: EntityEditModal,
    [CERTIFICATE_OF_GOOD_STANDING]: EntityEditModal,
    [CERTIFICATE_OF_GOOD_STANDING_BASE]: EntityEditModal,
    [CERTIFICATE_OF_EXISTENCE]: EntityEditModal,
    [BORROWER_LLC_CERTIFICATE_OF_GOOD_STANDING]: EntityEditModal,
    [OPERATING_AGREEMENT]: EntityEditModal,
    [BYLAWS]: EntityEditModal,
    [BORROWING_CORP_STOCK_CERTIFICATE]: EntityEditModal,
    [FOREIGN_ENTITY_REGISTRATION]: EntityEditModal,
    [GC_LICENSE]: LicenseEditModal,
    [BROKER_LICENSE]: LicenseEditModal,
    [CERT_OF_FORMATION_OR_INC]: EntityEditModal,
    [CERT_OF_GOOD_STANDING_OR_EXISTENCE]: EntityEditModal,
    [OPERATING_AGREEMENT_BYLAWS_STOCK]: EntityEditModal,
  }[itemName];
  if (!Content) return null;
  return <Content open={open} />;
};
